export default __webpack_public_path__ + "static/media/web-programming.5cb481b6.svg";